import { atom } from "recoil";

export const achievementCategoryEditModalStore = atom({
	key: "achievementCategoryEditModalStore",
	default: {
		show: false,
		loaded: true,
		id: 0,
		name: "",
		type: "",
		active: false,
		currentOptions: {
			type: [
				{ value: "daily", label: "Daily" },
				{ value: "unique", label: "Unique" },
				{ value: "progressive", label: "Progressive" },
			]
		}
	},
});
